import * as React from 'react';

import ActionLink from 'components/buttons/action-link/ActionLink';
import { withModal } from 'components/modal/ModalHOC';
import Tooltip from 'components/Tooltip';

import SubcampaignVariablePaymentsModal from '../../modals/SubcampaignVariablePaymentsModal';

import { __t, applyTranslations } from 'utils/language';
import { renderPrice } from 'utils/helper/price';

import './subcampaign-payouts-header-variable.scss';

import type { PaymentInfo, VariablePayment } from 'types';

applyTranslations(require('locales/common/collabary-common.i18n.json'));
applyTranslations(require('./subcampaign-payouts-header-variable.i18n.json'));

type MONETARY_TYPE = 'agreed' | 'variable';

type Props = {
  campaignName: string,
  paymentInfo: PaymentInfo,
  variablePayments: Array<VariablePayment>,
  variablePaymentsAmount: number,
  otherArrangement: boolean
};

const MSG_KEY = 'subcampaign_payouts_header_variable';

const TooltipWithViewModal = withModal(Tooltip, {
  modalContent: SubcampaignVariablePaymentsModal
});

class SubcampaignPayoutsHeaderVariable extends React.PureComponent<Props> {
  getNoValueText(type: MONETARY_TYPE): string {
    const { otherArrangement } = this.props;

    if (otherArrangement && type === 'agreed') {
      return __t(`${MSG_KEY}.labels.other_arrangement`);
    }

    return '';
  }

  hasNoVariablePayment(): boolean {
    return !this.props.paymentInfo.amounts.variable;
  }

  renderLabel(type: MONETARY_TYPE) {
    const {
      campaignName,
      variablePayments,
      variablePaymentsAmount
    } = this.props;


    if (type === 'variable') {
      return (
        <TooltipWithViewModal
          modalContentProps={{
            campaignName,
            variablePayments,
            variablePaymentsAmount
          }}
          width="macro"
          message={__t('collabary_common.basics.view')}
        >
          <ActionLink
            size="inherit"
            color="light"
          >
            {__t(`${MSG_KEY}.labels.${type}_payment`)}:
          </ActionLink>
        </TooltipWithViewModal>
      );
    }

    return (
      <div>
        {__t(`${MSG_KEY}.labels.${type}_payment`)}:
      </div>
    );
  }

  renderPaymentValue(type: MONETARY_TYPE): React.ReactNode {
    const { paymentInfo } = this.props;
    const value = paymentInfo.amounts[type] || 0;
    const label = __t(`${MSG_KEY}.labels.${type}_payment`);

    const updatedValue = value
      ? renderPrice(value, { defaultValue: this.getNoValueText(type) })
      : this.getNoValueText(type);

    return updatedValue && (
      <div className="subcampaign-payouts-header-variable__display">
        <div
          className="subcampaign-payouts-header-variable__label"
          title={`${label}: ${updatedValue}`}
        >
          {this.renderLabel(type)}
        </div>
        <div
          className="subcampaign-payouts-header-variable__value"
          title={`${label}: ${updatedValue}`}
        >
          <div>
            {updatedValue}
          </div>
        </div>
      </div>
    );
  }

  render(): React.ReactNode {
    if (this.hasNoVariablePayment()) {
      return null;
    }

    return (
      <div className="subcampaign-payouts-header-variable">
        {this.renderPaymentValue('agreed')}
        {this.renderPaymentValue('variable')}
      </div>
    );
  }
}

export default SubcampaignPayoutsHeaderVariable;
